import { NewInput, NewSelect } from ".";
import { NewFieldStyles, SelectFieldOption_Values } from "../../Definitions";
import { css, glyphs } from "../../Styles";
import FeedCorrectionPopover from "../LocationFeeder/feedCorrectionPopover";

/* eslint-disable */
export enum FieldMode {
  select="select",
  input="input",
  feedCorrection="feedCorrection",
}
/* eslint-enable */

type BaseProps = {
    editMode?: boolean
    header: string;
    icon: keyof typeof glyphs;
    value: string | number | undefined;
    isDisabled?: boolean;
    isClearable?: boolean;
    gridTemplateColumns?: string
  };

  type FeedCorrectionProps = BaseProps & {
    fieldMode: FieldMode.feedCorrection;
    onchange?: (e: number) => void;
    defaultValue?: number;
  }
  
  type SelectInputProps = BaseProps & {
    fieldMode: FieldMode.select;
    options: SelectFieldOption_Values[];
    onchange?: (e: SelectFieldOption_Values | undefined) => void;
    // onClear?: () => void;
    defaultValue?: SelectFieldOption_Values | undefined;
  };
  
  type TextInputProps = BaseProps & {
    fieldMode: FieldMode.input;
    onchange?: (e: string) => void;
    // onClear?: () => void;
    defaultValue?: string | number;
    type?: string
  };
  
  type InfoDisplayInputProps = SelectInputProps | TextInputProps | FeedCorrectionProps;

  export default function LineInfoDisplay(props: InfoDisplayInputProps) {
    const { header, icon, value, editMode, isDisabled, isClearable, gridTemplateColumns} = props;
    const IconComponent = glyphs[icon];
    
    const _fieldStyle = NewFieldStyles.greySecondary;
    const _fieldWidth = "100%"
    const _gridTemplateColumns = gridTemplateColumns ? gridTemplateColumns : "2fr 25px 3fr"
    if (props.fieldMode === FieldMode.input) {
      // console.log(props.defaultValue);
    }
    return (
      <div style={{...css.basic_Info_style, gridTemplateColumns: _gridTemplateColumns}}>
        <div style={{gridArea: "1/1/2/2", ...css.basicInfo_rightStyle}}>{header}</div>
        <div style={{gridArea: "1/2/2/3", ...css.basicInfo_centerStyle}}>{IconComponent && <IconComponent size="25px" />}</div>
        <div style={{gridArea: "1/3/2/4", ...css.basicInfo_leftStyle, marginLeft: editMode ? "5px" : "10px"}}>
        { editMode? 
          props.fieldMode === FieldMode.select ? 
            <NewSelect
              // onClear={props.onClear}
              onChange={props.onchange}
              options={props.options ?? []}
              isDisabled={isDisabled}
              isClearable={isClearable}
              fieldOverrides={{
                fieldStyle: _fieldStyle,
                fieldWidth: _fieldWidth
              }}
              valueOverrides={{
                defaultValue: props.defaultValue
              }}
            />
          : props.fieldMode === FieldMode.input ?
            <NewInput
              onChange={props.onchange}
              // onClear={props.onClear}
              isDisabled={isDisabled}
              isClearable={isClearable}
              fieldOverrides={{
                fieldStyle: _fieldStyle,
                fieldWidth: _fieldWidth
              }}
              valueOverrides={{
                defaultValue: props.defaultValue,
                valueType: props.type
              }}
            />
          : props.fieldMode === FieldMode.feedCorrection ?
            <FeedCorrectionPopover 
              onChange={props.onchange} 
              defaultValue={props.defaultValue}
              fieldOverrides={{
                fieldStyle: _fieldStyle
              }}
            />
          : <></>
          : <>{value}</> }
        </div>
      </div>
    )
  }